export default __webpack_public_path__ + "static/media/health-and-beauty.inline.d7b452f0.svg";